import AppSearch from '@/components/common/AppSearch';
import { useRouterPath } from '@/functions/routerPath';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { ReactNode, useEffect, useState } from 'react';
import styles from './styles.module.css';
import Button from '@/components/common/Button';
import { useTranslations } from 'next-intl';
import MainIcons from '@/icons/main';
import ToolbarIcons from '@/icons/toolbar';
import { setState } from '@/commonTypes';

export default function BlogSearch({
  page = null,
  className = '',
  affix,
  placeholder,
  setPageNumber,
  buttonClassName = '',
  searchKey = 'search',
}: {
  page?: string | null;
  className?: string;
  affix?: ReactNode;
  placeholder?: string;
  setPageNumber?: setState<string | number>;
  buttonClassName?: string;
  searchKey?: string;
}) {
  const params = useSearchParams();
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const tCommon = useTranslations('common');
  const [initial, setInitial] = useState<string | undefined>();
  // params.get('search') ? params.get('search') : '',
  useEffect(() => {
    if (params.get(searchKey)) {
      let searchParams = params?.get(searchKey);
      setInitial(searchParams ? searchParams : '');
    } else {
      setInitial();
    }
  }, [params]);
  const router = useRouter();
  const routerPath = useRouterPath();
  const callBackSearch = (value: string) => {
    // if (value?.trim()?.length != 0) {
    //   router.push(routerPath(`${page}?search=${value}`));
    // } else {
    //   if (initial?.trim()?.length != 0) {
    //     router.push(routerPath(`${page}`));
    //   }
    // }
    changepath(value);
  };
  // const changepath = (value: string) => {
  //   const params = new URLSearchParams(searchParams.toString());

  //   if (!value || value?.trim()?.length == 0) {
  //     params.delete(searchKey);
  //   } else {
  //     params.set(searchKey, value?.trim());
  //   }
  //   params.set('page', '1');
  //   setPageNumber && setPageNumber(1);
  //   const newPath = pathname.replace(/\/page\/\d+$/, '');

  //   router.push(`${newPath}${params.toString() ? `?${params.toString()}` : ''}`);
  // };
  const changepath = (value: string) => {
    const params = new URLSearchParams(searchParams.toString());

    if (!value || value.trim().length === 0) {
      params.delete(searchKey);
    } else {
      params.set(searchKey, value.trim());
    }

    const newPath = page ?? pathname.replace(/\/page\/\d+$/, '');

    // if (page != null) {
    //   params.delete('page');
    // } else {
    setPageNumber && params.set('page', '1');
    setPageNumber?.(1);
    // }

    console.log('newPath ==', newPath);
    console.log('query ==', params.toString());

    router.push(`${newPath}${params.toString() ? `?${params.toString()}` : ''}`);
  };
  return (
    // <Button
    //   useAsWrapper={true}
    //   showAnimation={false}
    //   showHover={true}
    //   wrapperStyle={`${styles.searchWrapper}`}
    //   className={`${styles.buttonChild}`}
    // >

    <AppSearch
      initialValue={initial}
      callBackonChange={(value?: string) => {
        setInitial(value);
      }}
      callbackSearch={(value: string) => {
        callBackSearch(value);
      }}
      className={`${styles.searchWrapper} ${className}`}
      // className={`${styles.searchWrapper}`}
      iconFill="var(--text-mut)"
      placeholder={placeholder}
      // searchInput={true}
      affix={
        affix ? (
          affix
        ) : (
          <Button className={`btn btn-primary squareButton ${styles.button} ${buttonClassName}`}>
            {tCommon('search')}
          </Button>
        )
      }
    />

    // </Button>
  );
}
